import { useLocation } from 'react-router-dom';

// AI Search is now in the navigation bar - this component is disabled
const AIChatbot = () => {
  return null;
};

export default AIChatbot;
